module.exports = __webpack_public_path__ + "static/media/12-Foundx.33f5d724.png";